import { Component, OnInit, ViewChild, ViewChildren, QueryList, EventEmitter, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { TylerMatTableDataSource } from '../../shared-components/angular-material/extended.class';
import { FilterComponent } from '../../shared-components/controls/filter/filter.component';
import { YearService } from '../../shared-components/year/year.service';
import { Year } from '../../shared-components/year/year.model';
import { StudentService } from '../../shared-components/student/student.service';
import { StudentDigitalContentService } from './student-digital-content.service';
import { StudentDigitalContent } from './models/student-digital-content.model';
import { MenuItem } from '../../shared-components/controls/menus/menu-item.model';
import { System } from '../../shared-components/System';
import { AddContentModalComponent } from './add-content-modal/add-content-modal.component';
import { GeneralConfirmationComponent } from '../../shared-components/controls/general-confirmation/general-confirmation.component';
import { UserService } from '../../shared-components/user/user.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
    selector: 'student-digital-content',
    templateUrl: './student-digital-content.component.html',
    styleUrls: ['./student-digital-content.component.scss']

})
export class StudentDigitalContentComponent implements OnInit, OnDestroy {

    // ------------Student Digital Content Data---------------------------
    studentDigitalContentData: StudentDigitalContent[] = [];

    // ------------Selection/Flags-----------------------------------
    student360Year: Year;
    V10: boolean;
    canAddEdit: boolean;
    canDelete: boolean;
    // ----------Angular Material------------------------------------
    dataSource = new TylerMatTableDataSource();
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    columnsToDisplay: string[] = ['FileName', 'Description', 'DocumentType', 'FormAddedBy', 'UploadedDate', 'Actions'];
    @ViewChildren(FilterComponent) filterRef: QueryList<FilterComponent>;
    topActionMenuItems: string[] = [];
    clearFilterEvent = new EventEmitter<any>();

    // ------------Modal Windows--------------------------------------
    deleteConfirmDialogRef: MatDialogRef<GeneralConfirmationComponent>;
    addContentDialogRef: MatDialogRef<AddContentModalComponent>;

    // --------------LifeCycle---------------------------------------

    constructor(private dialog: MatDialog,
        private yearService: YearService,
        private userService: UserService,
        private studentService: StudentService,
        private studentDigitalContentService: StudentDigitalContentService) { }

    ngOnInit() {
        // Initial data load
        this.getUserPermissions();

        this.studentService.selectedStudentStream$.subscribe(student => {
            this.getStudentDigitalContent();
        });
    }

    ngOnDestroy() {
    }


    // ------------Helper Methods---------------------------
    getStudentDigitalContent(): void {
        this.studentDigitalContentService.getStudentDigitalContent(this.studentService.selectedStudent.Id, this.yearService.student360Year.SchoolID).subscribe(result => {
            this.studentDigitalContentData = result;
            this.loadTableData();
        });
    }

    loadTableData() {
        this.dataSource.data = this.studentDigitalContentData;
        this.dataSource.sort = this.sort;
    }

    actionMenuClick(menuItem: MenuItem) {
        const data: StudentDigitalContent = menuItem.data;
        switch (menuItem.itemName) {
            case 'Edit':
                this.addClick(data);
                break;
            case 'Delete':
                this.deleteClick(data);
                break;
        }
    }

    viewFile(sdc: StudentDigitalContent) {
        System.viewFileFromBase(sdc.MyFileBase64String, sdc.DocumentMimeType, sdc.FileName);
    }

    addClick(sdc?: StudentDigitalContent) {
        this.addContentDialogRef = this.dialog.open(AddContentModalComponent, {
            disableClose: true,
            data: {
                sdc: sdc
            },
        });

        this.addContentDialogRef.afterClosed().subscribe(saveClicked => {
            if (saveClicked) {
                this.getStudentDigitalContent();
            }
        });
    }

    deleteClick(data: StudentDigitalContent) {
        this.deleteConfirmDialogRef = this.dialog.open(GeneralConfirmationComponent, {
            panelClass: 'tyl-mat-dialog', disableClose: true
        });

        this.deleteConfirmDialogRef.componentInstance.headerLabel = 'Delete Document';

        if (data.FileName.length > 50) {
            this.deleteConfirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete the document "' + data.FileName.substring(0, 49) + '"...?';
        }
        else {
            this.deleteConfirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete the document "' + data.FileName + '"?';
        }

        this.deleteConfirmDialogRef.componentInstance.okButtonLabel = "Delete";

        this.deleteConfirmDialogRef.componentInstance.confirmEvent.subscribe((deleteObject: boolean) => {
            if (deleteObject) {
                this.studentDigitalContentService.deleteStudentDigitalContent(data.DocumentId).subscribe(result => {
                    this.getStudentDigitalContent();
                });
            }
        });
    }

    getUserPermissions() {
        // POST: obtains the permissions from the server
        this.userService.getUserPermissions(
            this.yearService.student360Year.Id,
            this.yearService.student360Year.SchoolID
        ).subscribe(permissions => {

            if (permissions.findIndex(x => x.PrivilegeId == 1052) != -1) {
                this.canAddEdit = true;
                this.topActionMenuItems.push('Edit');
            }

            if (permissions.findIndex(x => x.PrivilegeId == 1800) != -1) {
                this.canDelete = true;
                this.topActionMenuItems.push('Delete');
            }

            if (!this.canAddEdit && !this.canDelete) {
                const index: number = this.columnsToDisplay.indexOf('Actions');
                this.columnsToDisplay.splice(index, 1);
            }
        });
    }

    clearFilter() {
        this.dataSource.removeAllFilters();
        this.clearFilterEvent.emit();
    }
}

